import { Injectable } from "@angular/core";
import { HttpClientService } from "./http-client.service";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";

@Injectable()
export class CommissionSchemesService {
  constructor(private http: HttpClientService) {}

  public post(commission_scheme): Observable<any> {
    return this.http
      .post("/api/commission_schemes", commission_scheme)
      .pipe(tap((_) => console.log("CommissionSchemesService.post: Ok.")));
  }

  public updateCommissionScheme(id, data): Observable<any> {
    return this.http
      .put("/api/commission_schemes/" + id, data)
      .pipe(tap((_) => console.log("CommissionSchemesService.update: Ok.")));
  }

  public delete(id): Observable<any> {
    return this.http
      .delete("/api/commission_schemes/" + id)
      .pipe(tap((_) => console.log("CommissionSchemesService.delete: Ok.")));
  }

  public downloadApprovalLetter(data): Observable<any> {
    return this.http
      .post("/api/commission_schemes/download_approval_letter", data, { responseType: "blob" as "json" })
      .pipe(tap((_) => console.log("CommissionSchemesService.downloadApprovalLetter: Ok.")));
  }
}
